import { render, staticRenderFns } from "./MobileErrorPage.vue?vue&type=template&id=57404e8e&scoped=true"
import script from "./MobileErrorPage.vue?vue&type=script&lang=js"
export * from "./MobileErrorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57404e8e",
  null
  
)

export default component.exports